import { extend } from '../util';
import VueTransition from './transition';
import { useTransitionHook } from './hook';
var Transition = extend(VueTransition, {
  useHook: useTransitionHook
});
export { default as Transition } from './transition';
export default Transition;